export default "__VITE_ASSET__2430d382__"